function _extends() {_extends = Object.assign ? Object.assign.bind() : function (target) {for (var i = 1; i < arguments.length; i++) {var source = arguments[i];for (var key in source) {if (Object.prototype.hasOwnProperty.call(source, key)) {target[key] = source[key];}}}return target;};return _extends.apply(this, arguments);}import React from 'react';
import { connect } from 'react-redux';
import { useNavigate, NavLink } from 'react-router-dom';
import { omit } from 'lodash';

const defaultProps = {
  disabled: false,
  onClick: (_e) => {},
  confirmTitle: '',
  confirmMessage: '',
  replaceNavigationHistory: false
};












const I18NLink = (props) => {
  const {
    to = '/',
    disabled,
    confirmTitle,
    confirmMessage,
    onClick,
    replaceNavigationHistory: replace
  } = props;

  const navigate = useNavigate();

  const onClickHandler = (e) => {
    e.preventDefault();

    if (disabled) return;

    if (onClick && confirmTitle) {
      props.mainContext.confirm({
        accept: () => {
          onClick(e);
          navigate(to, { replace });
        },
        title: confirmTitle,
        message: confirmMessage
      });
      return;
    }

    if (onClick) {
      onClick(e);
      navigate(to, { replace });
      return;
    }

    navigate(to, { replace });
  };

  const newProps = omit(props, [
  'dispatch',
  'onClick',
  'confirmTitle',
  'confirmMessage',
  'to',
  'activeclassname']
  );

  return /*#__PURE__*/(
    React.createElement(NavLink, _extends({
      end: true,
      to: props.to,
      onClick: onClickHandler,
      className: ({ isActive }) => isActive ? props.activeclassname : undefined },
    newProps)
    ));

};

export function mapStateToProps({ locale }, ownProps) {
  return { to: `/${locale || ''}/${ownProps.to}`.replace(/\/+/g, '/') };
}


export { I18NLink };
export default connect(mapStateToProps)(I18NLink);